/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 *
 * @export
 * @interface ApplyBookingCreditsRequest
 */
export interface ApplyBookingCreditsRequest {
    /**
     * Authoritative booking owner. Required with policy_version and accepted only from api_search.
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    userId?: string;
    /**
     *
     * @type {boolean}
     * @memberof ApplyBookingCreditsRequest
     */
    usedGondolaCredits: boolean;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof ApplyBookingCreditsRequest
     */
    commissionableCost?: CurrencyAmount;
    /**
     *
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    scheduledEventCode?: string;
    /**
     * The platform the booking was made from
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    userEnvironment?: ApplyBookingCreditsRequestUserEnvironmentEnum;
    /**
     * Type of booking. Determines cashback rate: hotel (3/5/7%) or vehicle (1/2/3%).
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    bookingType?: ApplyBookingCreditsRequestBookingTypeEnum;
    /**
     * Gondola booking ID being replaced by this booking. Fixed rewards transfer only after replacement succeeds.
     * @type {number}
     * @memberof ApplyBookingCreditsRequest
     */
    sourceBookingId?: number;
    /**
     * Internal automatic replacement context. Requires verified savings for the matching replacement before reward delivery.
     * @type {boolean}
     * @memberof ApplyBookingCreditsRequest
     */
    isAutoSave?: boolean;
    /**
     * Immutable booking-time cashback rate as a decimal multiplier. Required with policy_version.
     * @type {number}
     * @memberof ApplyBookingCreditsRequest
     */
    cashbackPercentage?: number;
    /**
     *
     * @type {CurrencyAmount}
     * @memberof ApplyBookingCreditsRequest
     */
    bookingDebit?: CurrencyAmount;
    /**
     * Trusted immutable booking creation time from api_search; never dispatch time.
     * @type {Date}
     * @memberof ApplyBookingCreditsRequest
     */
    bookedAt?: Date;
    /**
     * Trusted AutoSave source hint; verified against persisted replacement lineage before transfer.
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    sourceHotelStayId?: string;
    /**
     * Version of the internal reward calculation contract. Presence opts into atomic replay-safe application.
     * @type {string}
     * @memberof ApplyBookingCreditsRequest
     */
    policyVersion?: string;
}


/**
 * @export
 */
export const ApplyBookingCreditsRequestUserEnvironmentEnum = {
    Web: 'WEB',
    MobileIos: 'MOBILE_IOS',
    MobileAndroid: 'MOBILE_ANDROID',
    Other: 'OTHER'
} as const;
export type ApplyBookingCreditsRequestUserEnvironmentEnum = typeof ApplyBookingCreditsRequestUserEnvironmentEnum[keyof typeof ApplyBookingCreditsRequestUserEnvironmentEnum];

/**
 * @export
 */
export const ApplyBookingCreditsRequestBookingTypeEnum = {
    Hotel: 'hotel',
    Vehicle: 'vehicle'
} as const;
export type ApplyBookingCreditsRequestBookingTypeEnum = typeof ApplyBookingCreditsRequestBookingTypeEnum[keyof typeof ApplyBookingCreditsRequestBookingTypeEnum];


/**
 * Check if a given object implements the ApplyBookingCreditsRequest interface.
 */
export function instanceOfApplyBookingCreditsRequest(value: object): value is ApplyBookingCreditsRequest {
    if (!('usedGondolaCredits' in value) || value['usedGondolaCredits'] === undefined) return false;
    return true;
}

export function ApplyBookingCreditsRequestFromJSON(json: any): ApplyBookingCreditsRequest {
    return ApplyBookingCreditsRequestFromJSONTyped(json, false);
}

export function ApplyBookingCreditsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyBookingCreditsRequest {
    if (json == null) {
        return json;
    }
    return {

        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'usedGondolaCredits': json['used_gondola_credits'],
        'commissionableCost': json['commissionable_cost'] == null ? undefined : CurrencyAmountFromJSON(json['commissionable_cost']),
        'scheduledEventCode': json['scheduled_event_code'] == null ? undefined : json['scheduled_event_code'],
        'userEnvironment': json['user_environment'] == null ? undefined : json['user_environment'],
        'bookingType': json['booking_type'] == null ? undefined : json['booking_type'],
        'sourceBookingId': json['source_booking_id'] == null ? undefined : json['source_booking_id'],
        'isAutoSave': json['is_auto_save'] == null ? undefined : json['is_auto_save'],
        'cashbackPercentage': json['cashback_percentage'] == null ? undefined : json['cashback_percentage'],
        'bookingDebit': json['booking_debit'] == null ? undefined : CurrencyAmountFromJSON(json['booking_debit']),
        'bookedAt': json['booked_at'] == null ? undefined : (new Date(json['booked_at'])),
        'sourceHotelStayId': json['source_hotel_stay_id'] == null ? undefined : json['source_hotel_stay_id'],
        'policyVersion': json['policy_version'] == null ? undefined : json['policy_version'],
    };
}

export function ApplyBookingCreditsRequestToJSON(json: any): ApplyBookingCreditsRequest {
    return ApplyBookingCreditsRequestToJSONTyped(json, false);
}

export function ApplyBookingCreditsRequestToJSONTyped(value?: ApplyBookingCreditsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'user_id': value['userId'],
        'used_gondola_credits': value['usedGondolaCredits'],
        'commissionable_cost': CurrencyAmountToJSON(value['commissionableCost']),
        'scheduled_event_code': value['scheduledEventCode'],
        'user_environment': value['userEnvironment'],
        'booking_type': value['bookingType'],
        'source_booking_id': value['sourceBookingId'],
        'is_auto_save': value['isAutoSave'],
        'cashback_percentage': value['cashbackPercentage'],
        'booking_debit': CurrencyAmountToJSON(value['bookingDebit']),
        'booked_at': value['bookedAt'] == null ? value['bookedAt'] : value['bookedAt'].toISOString(),
        'source_hotel_stay_id': value['sourceHotelStayId'],
        'policy_version': value['policyVersion'],
    };
}

